var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 21",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.772 6.783 1.102 11.558 1.436 1.38h7.077l1.38-1.38 1.331-11.558M6.652 7.783l.416 9M11.068 7.783l-.416 9M1.373 4.532H16.37M4.87 1.5h8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/binIcon.38901040024f4c705f01d7889f860179.svg";
export { ForwardRef as ReactComponent };